import React, { useState } from 'react'
import { Nav, Row, Tab } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { Route, Switch, useRouteMatch } from 'react-router'
import {
  getUserModuleActions,
  getUserSubModuleActions,
} from '../../../../store/user/selectors'
import { checkPermission } from '../../../../utils/utilFunctions'
import Add from '../fileRegistration/add/Add'
import ApplicationFileComponent from './ApplicationFileComponent'
import ApplicationFileReturnComponent from './ApplicationFileReturnComponent'
import ApplicationFileView from './ApplicationFileView'

const ApplicationFile = () => {
  const { path } = useRouteMatch()
  const [selectedSection, setSelectedSection] = useState('application-file')

  const actionListModule = useSelector(
    getUserModuleActions(
      'application-registration',
      'file-registration',
      'application-files'
    )
  )

  const actionListSubModule = useSelector(
    getUserSubModuleActions(
      'application-registration',
      'file-registration',
      'application-files',
      'file-return'
    )
  )
  return (
    <Switch>
      <Route path={`${path}/`} exact>
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey="application-file"
        >
          <Row className="tab-page-layout">
            <Nav variant="pills" className="flex-row">
              {checkPermission('view', actionListModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('application-file')
                    }}
                    eventKey="application-file"
                  >
                    Application Files
                  </Nav.Link>
                </Nav.Item>
              )}
              {checkPermission('view', actionListSubModule) && (
                <Nav.Item className="custom-nav-item">
                  <Nav.Link
                    onClick={() => {
                      setSelectedSection('application-file-return')
                    }}
                    eventKey="application-file-return"
                  >
                    Application File Returns
                  </Nav.Link>
                </Nav.Item>
              )}
            </Nav>
          </Row>
          <Row className="page-tiles-layout align-content-start">
            {selectedSection === 'application-file' ? (
              <>
                {checkPermission('view', actionListModule) && (
                  <ApplicationFileComponent />
                )}
              </>
            ) : (
              <>
                {checkPermission('view', actionListSubModule) && (
                  <ApplicationFileReturnComponent />
                )}
              </>
            )}
          </Row>
        </Tab.Container>
      </Route>
      <Route
        path={`${path}/view/:id`}
        render={(props) => <ApplicationFileView type="file" {...props} />}
      />
      <Route
        path={`${path}/file-return/view/:id`}
        render={(props) => (
          <Add isDraft={true} isReturn={true} type="file-return" {...props} />
        )}
      />
    </Switch>
  )
}

export default ApplicationFile
